import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { formatCop, isMoneyValue, toDecimal, } from "../lib/money.js";
import { cn } from "../lib/utils.js";
const moneyTextVariants = cva('whitespace-nowrap tabular-nums', {
    variants: {
        size: {
            sm: 'text-sm font-medium',
            md: 'text-base font-semibold',
            lg: 'font-display text-2xl font-semibold',
            xl: 'font-display text-4xl leading-none font-semibold',
        },
        tone: {
            default: 'text-foreground',
            primary: 'text-primary',
            muted: 'text-muted-foreground',
            positive: 'text-success',
            negative: 'text-destructive',
            inverse: 'text-inverse-foreground',
            /** Verde para entradas, por defecto para salidas (según el signo). */
            auto: '',
        },
    },
    defaultVariants: { size: 'md', tone: 'default' },
});
/** Muestra un monto en pesos: `$ 1.200.000`. Solo presenta cifras; no calcula. */
function MoneyText({ value, decimals, sign, size, tone, fallback = '—', className, ...props }) {
    if (!isMoneyValue(value)) {
        return (_jsx("span", { "data-slot": "money-text", className: cn(moneyTextVariants({ size, tone: 'muted' }), className), children: fallback }));
    }
    const amount = toDecimal(value);
    const text = formatCop(amount, { decimals, sign });
    const resolvedTone = tone === 'auto' ? (amount.greaterThan(0) ? 'positive' : 'default') : tone;
    return (_jsx("data", { "data-slot": "money-text", value: amount.toFixed(), className: cn(moneyTextVariants({ size, tone: resolvedTone }), className), ...props, children: text }));
}
export { MoneyText, moneyTextVariants };
//# sourceMappingURL=money-text.js.map